import { render, staticRenderFns } from "./SystemErrorPage.vue?vue&type=template&id=7b410f06&scoped=true&"
import script from "./SystemErrorPage.vue?vue&type=script&lang=js&"
export * from "./SystemErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./SystemErrorPage.vue?vue&type=style&index=0&id=7b410f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b410f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b410f06')) {
      api.createRecord('7b410f06', component.options)
    } else {
      api.reload('7b410f06', component.options)
    }
    module.hot.accept("./SystemErrorPage.vue?vue&type=template&id=7b410f06&scoped=true&", function () {
      api.rerender('7b410f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/SystemErrorPage.vue"
export default component.exports